import type {
	Components,
} from '@mui/material'

export const materialUIAccordionTheme: {
	components: Components
} = {
	components: {
		MuiBreadcrumbs: {
			styleOverrides: {
			},
		},
		MuiAccordion: {
			defaultProps: {
				elevation: 0,
			},
			styleOverrides: {
				root: {
				},
			},
			variants: [
			],
		},
		MuiAccordionSummary: {
			styleOverrides: {
				root: {
				},
			},
		},
	},
}
